const BASIS_TOGGLE_ENABLED_DEMOS: readonly string[] = ['JobberProjects']

export const isBasisToggleEnabled = (demoName?: string | null): boolean =>
  !!demoName && BASIS_TOGGLE_ENABLED_DEMOS.includes(demoName)
